import React from "react";
import Select from "react-select";

import { IS_VALID } from "utils";

let schema = {
  className: "PendingNotification",
  limit: 10,
  showCreate: false,
  showExport: false,
  columns: [
    {
      columnName: "objectId",
      type: "string"
    },
    {
      columnName: "subject",
      type: "string",
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      }
    },
    {
      columnName: "User",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
    {
      columnName: "Sender",
      type: "pointer",
      targetClass: "User",
      displayColumn: "name",
      headerStyle: {
        minWidth: 150
      }
    },
    {
      columnName: "status",
      type: "string",
      headerStyle: {
        minWidth: 145
      },
      render: ({ object}) => {
        let renderValue = "PENDING";

        if (IS_VALID(object.get("status"))) {
          renderValue = object.get("status");
        }

        return renderValue;
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "PENDING",
                  value: "PENDING"
                },
                {
                  label: "APPROVED",
                  value: "APPROVED"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            if (value.value === "PENDING") {
              query.doesNotExist("status");
            } else {
              query.equalTo("status", value.value);
            }
          }

          return query;
        }
      }
    },
    {
      columnName: "message",
      type: "string",
      show: false,
      style: {
        whiteSpace: "normal",
        minWidth: "300px"
      }
    },
    {
      columnName: "sendMode",
      columnLabel: "send mode",
      type: "string",
      headerStyle: {
        minWidth: 101,
        whiteSpace: "nowrap"
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "TEST",
                  value: "TEST"
                },
                {
                  label: "LIVE",
                  value: "LIVE"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("sendMode", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "sendType",
      columnLabel: "send Type",
      type: "string",
      headerStyle: {
        minWidth: 154
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "IMMEDIATE",
                  value: "IMMEDIATE"
                },
                {
                  label: "SCHEDULED",
                  value: "SCHEDULED"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("sendType", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "device",
      type: "string",
      headerStyle: {
        minWidth: 133
      },
      customFilter: {
        display: (value, onChange) => {
          return (
            <Select
              options={[
                {
                  label: "ALL",
                  value: "ALL"
                },
                {
                  label: "ANDROID",
                  value: "ANDROID"
                },
                {
                  label: "IOS",
                  value: "IOS"
                }
              ]}
              value={value !== "" ? value : null}
              onChange={onChange}
              />
          );
        },
        onSearch: ({ query, value }) => {
          if (IS_VALID(value.value)) {
            query.equalTo("device", value.value);
          }

          return query;
        }
      }
    },
    {
      columnName: "createdAt",
      type: "Date"
    },
    {
      columnName: "updatedAt",
      type: "Date"
    }
  ]
};

module.exports = schema;



// WEBPACK FOOTER //
// ./components/PendingNotification/PendingNotificationSchema.js